/**
 * Textarea Component
 * Standard form textarea with consistent styling
 */

import * as React from 'react'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    error?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, error, ...props }, ref) => {
        return (
            <textarea
                className={`
          flex min-h-[80px] w-full rounded-lg border bg-gray-900/50 px-3 py-2 
          text-sm text-white placeholder:text-gray-500
          border-gray-700 
          focus:outline-none focus:ring-2 focus:ring-green-500/50 focus:border-green-500
          disabled:cursor-not-allowed disabled:opacity-50
          transition-colors duration-200
          resize-y
          ${error ? 'border-red-500 focus:ring-red-500/50 focus:border-red-500' : ''}
          ${className || ''}
        `.trim().replace(/\s+/g, ' ')}
                ref={ref}
                {...props}
            />
        )
    }
)
Textarea.displayName = 'Textarea'

export { Textarea }
